import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, InputNumber, Select, Space } from '@vivaldis/antd-ui'
import { PremiumUnitsEnum } from '../../../../../../../typings/PremiumUnitsEnum'

interface Props {
  index: number
}

export const MorningShiftBonus = ({ index }: Props) => {
  const { t } = useTranslation('web_ui')

  const valueFieldName = `premiumValuesInput[${index}].value`
  const unitFieldName = `premiumValuesInput[${index}].unit`

  const unitOptions = useMemo(() => {
    return [
      {
        label: t('position_form.step3.morning_shift_bonus.units.percent'),
        value: PremiumUnitsEnum.PERCENT
      },
      {
        label: t('position_form.step3.morning_shift_bonus.units.per_hour'),
        value: PremiumUnitsEnum.PER_HOUR
      }
    ]
  }, [t])

  return (
    <Form.Item
      name={valueFieldName}
      required
      label={t('position_form.step3.morning_shift_bonus.value.label')}
      tooltip={t('position_form.step3.morning_shift_bonus.value.tooltip')}
    >
      <Space.Compact block>
        <Select
          name={unitFieldName}
          options={unitOptions}
          style={{ width: 56 }}
        />
        <InputNumber
          name={valueFieldName}
          autoComplete="off"
          min={0}
          placeholder={t(
            'position_form.step3.morning_shift_bonus.value.placeholder'
          )}
          style={{ flexGrow: 1 }}
        />
        <Space.Addon>
          {t('position_form.step3.morning_shift_bonus.value.addon_after')}
        </Space.Addon>
      </Space.Compact>
    </Form.Item>
  )
}
